import './css/App.css';
import Explanation from "./explanation/explanation";
import StartPage from "./startpage";
import Practice from './practice/practice';
import { BrowserRouter,Routes, Route } from "react-router-dom";
	
/**
 * @author: Alisa Münsterberg
 * @date: 2022-10-14
 */

 function App() {
	return (
	  <div className="App">
		<BrowserRouter basename='/ITS/BubbleSort/'>
			<Routes>
				<Route path="/explanation" element={<Explanation />}/>
				<Route path="/practice" element={<Practice />}/>
				<Route exact path="/" element={<StartPage />}/>
			</Routes>
		</BrowserRouter>
		</div>
	  );
	}
	
export default App;

